import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map, List } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { DateTimePicker } from '@material-ui/pickers';
import { withStyles, CircularProgress, Grid } from '@material-ui/core';
import { FHERadio, FHEContainerScroll, FHEWysiwyg, FHEContainerForm, FHETitle, FHETextField, FHESelectField, FHEReactSelect } from 'data/components';
import { Toastr, tools } from 'data/common';
import { SvgTicket } from 'data/common/iconsvg';
import memoizeOne from 'memoize-one';
import NotificationButton from '../components/NotificationButton';
import Preview from '../components/Preview';
import FormActionsButtons from '../components/FormActionsButtons';

const moment = require('moment-timezone');

class FormNotification extends PureComponent {
    static propTypes = {
        notification: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        homes: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        defaultButtonsArray: PropTypes.array.isRequired,
        homesArray: PropTypes.array.isRequired,
        match: PropTypes.object.isRequired,
        sendDataFunc: PropTypes.func.isRequired,
        type: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            displayPreview: false,
            buttonsLoading: false,
            loading: true,
            formDisabled: true,
            formDisabledPartial: false,
            textInput_error: {},
            sendLoading: false,
            buttonIds: [],
            selectedHomes: []
        };
        this.types = [
            { value: 'persistant', label: Translator.translate(`generic.notification.type.persistant`) },
            { value: 'oneshot', label: Translator.translate('generic.notification.type.oneshot') }
        ];
        this.priorities = [
            { value: 'information', label: Translator.translate(`generic.notification.priority.information`) },
            { value: 'critical', label: Translator.translate(`generic.notification.priority.critical`) },
            { value: 'warning', label: Translator.translate('generic.notification.priority.warning') }
        ];
    }

    componentDidMount() {
        this.loadInputs(true);
    }

    getFormData = () => {
        const { type, notification } = this.props;

        return {
            title: type === 'add' ? null : notification.get('title'),
            messageFR: type === 'add' ? null : notification.get('messageFR'),
            type: type === 'add' ? 'persistant' : notification.get('type'),
            priority: type === 'add' ? 'information' : notification.get('priority'),
            startDate:
                type === 'update'
                    ? moment(notification.get('startDate'), 'DD/MM/YYYY hh:mm:ss').unix()
                    : moment()
                          .add(1, 'days')
                          .unix(),
            endDate:
                type === 'update'
                    ? moment(notification.get('endDate'), 'DD/MM/YYYY hh:mm:ss').unix()
                    : moment()
                          .add(2, 'days')
                          .unix(),
            userChoice: type === 'add' ? 'all_except' : notification.get('userChoice'),
            homeIds: type === 'add' ? null : notification.getIn(['homeIds'], new List()).toJSON()
        };
    };

    handleEdit = () => {
        const { formDisabled, notificationForm } = this.state;

        if (!formDisabled) this.loadInputs();
        this.setState({
            formDisabledPartial: notificationForm.startDate <= moment().unix(),
            formDisabled: !formDisabled,
            textInput_error: {}
        });
    };

    handleChange = event => {
        const { notificationForm, textInput_error } = this.state;
        let targetValue = event.target.value;
        const fieldLengthRules = {
            titre: 255
        };

        let newTextInput_error = this.removeKey(textInput_error, event.target.name);

        let maxLength = fieldLengthRules[event.target.name];
        if (maxLength && targetValue.length > maxLength) targetValue = notificationForm[event.target.name];
        this.setState({
            notificationForm: { ...notificationForm, [event.target.name]: targetValue },
            textInput_error: newTextInput_error
        });
    };

    removeKey = (myObj, deleteKey) => {
        const newObj = { ...myObj };
        delete newObj[deleteKey];
        return newObj;
    };

    handleFormError = (fields, message) => {
        let res = {};
        Object.keys(fields).map(field => {
            fields[field].forEach(error => {
                if (res[field] === undefined) res[field] = [];

                res[field].push(
                    <p key={error} className="mb-1">
                        {Translator.translate(`general.fields.error.${error}`)}
                    </p>
                );
            });
        });

        this.setState({
            textInput_error: res
        });

        return Toastr.error(message);
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    confirmEdit = () => {
        const { notificationForm } = this.state;
        const { sendDataFunc, match } = this.props;
        let form = {};
        if (notificationForm.startDate <= moment().unix()) form = this.formatFormEndDateExpired();
        else form = this.formatFormFull();
        if (this.validateForm(form)) {
            this.setState({
                sendLoading: true,
                formDisabled: true
            });
            return sendDataFunc(match.params.notificationId, form)
                .then(() => {
                    Toastr.success(Translator.translate('generic.notification.actions.editNotificationSuccess', notificationForm.title));
                    this.loadInputs();
                    this.setState({
                        formDisabled: true,
                        sendLoading: false
                    });
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                        formDisabled: false
                    });
                    Toastr.error(
                        Translator.translateWithFallback(
                            `api.message.${error.message}`,
                            'generic.notification.actions.editNotificationError',
                            notificationForm.title
                        )
                    );
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(
                            error.validation.errors,
                            Translator.translate('generic.notification.actions.editNotificationError', notificationForm.title)
                        );
                    }
                });
        }
    };

    saveNotification = () => {
        const { notificationForm } = this.state;
        const { sendDataFunc, history, profile } = this.props;
        const form = this.formatFormFull();
        if (this.validateForm(form)) {
            this.setState({
                formDisabled: true,
                sendLoading: true
            });
            return sendDataFunc(form)
                .then(data => {
                    const notificationId = data.notificationId;
                    Toastr.success(Translator.translate('generic.notification.actions.addNotificationSuccess', data.notificationDetails.title));
                    if (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('notificationDetails'))
                        return history.push(`/${history.environment}/notifications/detail/${notificationId}`);
                    return history.push(`/${history.environment}/notifications`);
                })
                .catch(error => {
                    Toastr.error(Translator.translate('generic.notification.actions.addNotificationError', notificationForm.title));
                    this.setState({
                        formDisabled: false,
                        sendLoading: false
                    });
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(
                            error.validation.errors,
                            Translator.translate('generic.notification.actions.addNotificationError', notificationForm.title)
                        );
                    }
                });
        }
    };

    handleEditor = data => {
        const { notificationForm, textInput_error } = this.state;
        const newTextInput_error = this.removeKey(textInput_error, 'messageFR');

        this.state.notificationForm = { ...notificationForm, messageFR: data };
        this.setState({
            textInput_error: newTextInput_error
        });
    };

    duplicate = () => {
        const { history, match } = this.props;
        history.push({
            pathname: '/fhe/notifications/add',
            state: { notificationId: match.params.notificationId }
        });
    };

    togglePreview = () => {
        this.setState(prevState => ({
            displayPreview: !prevState.displayPreview
        }));
    };

    handleChangeReactSelect = event => {
        this.setState({
            selectedHomes: event
        });
    };

    handleChangeMultiple = event => {
        const { textInput_error } = this.state;
        const newTextInput_error = this.removeKey(textInput_error, 'buttons');
        this.setState({
            buttonIds: event.target.value,
            textInput_error: newTextInput_error
        });
    };

    handleCancel = () => {
        const { history } = this.props;
        history.goBack();
    };

    onStartDateChange = date => {
        const { notificationForm } = this.state;
        this.setState({
            notificationForm: { ...notificationForm, startDate: moment(date).unix() }
        });
    };

    onEndDateChange = date => {
        const { notificationForm } = this.state;
        this.setState({
            notificationForm: { ...notificationForm, endDate: moment(date).unix() }
        });
    };

    validateForm(form) {
        const { formDisabledPartial } = this.state;
        const errors = {};
        const namesArray = ['title', 'buttons'];
        const messageMaxLength = 65535;

        if (formDisabledPartial) return true;

        namesArray.forEach(name => {
            if (this.isEmpty(form[name])) errors[name] = Translator.translate('general.fields.error.any.empty');
        });
        if (form.messageFR === null) errors.messageFR = Translator.translate('general.fields.error.any.empty');
        else {
            if (form.messageFR.replace(/(<([^>]+)>)|(&nbsp;)/gi, '').trim() === '')
                errors.messageFR = Translator.translate('general.fields.error.any.empty');
            else if (form.messageFR.length > messageMaxLength) errors.messageFR = Translator.translate('general.fields.error.any.lengthExceeded');
        }

        this.setState({
            textInput_error: errors
        });
        return Object.keys(errors).length <= 0;
    }

    formatFormFull() {
        const { notificationForm, buttonIds, selectedHomes } = this.state;
        const { defaultButtonsArray } = this.props;
        const form = { ...notificationForm };
        if (buttonIds) {
            form.buttons = buttonIds.map(id => defaultButtonsArray.find(btn => btn.value === id.toString()).data);
        }
        if (selectedHomes) {
            form.homeIds = selectedHomes.map(home => parseInt(home.value));
        }
        return form;
    }

    formatFormEndDateExpired() {
        const { notificationForm } = this.state;

        const form = {};
        form.endDate = notificationForm.endDate;
        return form;
    }

    loadInputs(didMount = false) {
        const { notification, homes, type } = this.props;

        const arraySelectedHomes = [];
        notification.getIn(['homeIds'], new List()).forEach(id => {
            const home = homes.getIn([id.toString()]);
            arraySelectedHomes.push({ value: id.toString(), label: home ? home.get('label') : '' });
        });

        const arraySelectedButtonIds = [];
        notification.getIn(['buttons'], new Map()).forEach(btn => {
            if (btn.get('buttonId')) arraySelectedButtonIds.push(btn.get('buttonId').toString());
        });

        this.setState({
            notificationForm: this.getFormData(),
            selectedHomes: arraySelectedHomes,
            buttonIds: arraySelectedButtonIds,
            loading: false,
            formDisabled: type === 'update' && didMount
        });
    }

    getSelectedPriority = memoizeOne(priority => {
        return this.priorities.find(x => x.value === priority);
    });

    getSelectedType = memoizeOne(type => {
        return this.types.find(x => x.value === type);
    });

    getSelectedButtons = memoizeOne(buttonIds => {
        const { defaultButtonsArray } = this.props;

        if (buttonIds) {
            return buttonIds.reduce((acc, buttonId) => {
                const btn = defaultButtonsArray.find(x => x.value === buttonId);
                return [...acc, btn];
            }, []);
        }
    });

    handleReactSelect = (event, options) => {
        const { notificationForm, textInput_error } = this.state;
        const newTextInput_error = tools.removeKey(textInput_error, options.name);
        if (options.name === 'buttons') {
            this.setState({
                buttonIds: event ? event.map(x => x.value) : null,
                textInput_error: newTextInput_error
            });
        }

        this.setState({
            notificationForm: { ...notificationForm, [options.name]: event.value },
            textInput_error: newTextInput_error
        });
    };
    customRender = ({ value }) => {
        const { defaultButtonsArray } = this.props;
        return defaultButtonsArray.find(x => x.value === value).component;
    };

    render() {
        const {
            selectedHomes,
            buttonIds,
            displayPreview,
            textInput_error,
            loading,
            formDisabled,
            sendLoading,
            notificationForm,
            buttonsLoading,
            formDisabledPartial
        } = this.state;
        const { profile, type, classes, notification, defaultButtonsArray, homesArray } = this.props;
        const updateRights = profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('notificationDetailsUpdate');
        const duplicateRights = profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes('notificationAdd');
        if (loading || buttonsLoading) {
            return (
                <FHEContainerForm>
                    <div className={classes.loadingContainer}>
                        <CircularProgress />
                    </div>
                </FHEContainerForm>
            );
        }
        return (
            <Fragment>
                {type === 'add' && <FHETitle title={Translator.translate('general.addNotification')} Icon={SvgTicket} />}
                <Preview
                    isOpen={displayPreview}
                    header={notificationForm.priority}
                    closeFunc={this.togglePreview}
                    content={notificationForm.messageFR}
                    defaultButtons={defaultButtonsArray}
                    buttonIds={buttonIds}
                />
                <FormActionsButtons
                    type={type}
                    updateRights={updateRights}
                    duplicateRights={duplicateRights}
                    duplicate={notificationForm.endDate <= moment().unix()}
                    handleCancel={this.handleCancel}
                    formDisabled={formDisabled}
                    handleEdit={this.handleEdit}
                    confirmEdit={this.confirmEdit}
                    confirmSave={this.saveNotification}
                    sendLoading={sendLoading}
                    confirmDuplicate={this.duplicate}
                    togglePreview={this.togglePreview}
                />
                {(type === 'update' || type === 'duplicate') && <FHETitle title={notification.get('title')} Icon={SvgTicket} />}
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12}>
                                <FHETextField
                                    disabled={formDisabledPartial || formDisabled}
                                    id="title"
                                    value={notificationForm.title}
                                    error={textInput_error.title}
                                    label={Translator.translate('general.table.column.title')}
                                    name="title"
                                    onChange={this.handleChange}
                                />
                            </Grid>

                            <Grid container item sm={12}>
                                <FHEWysiwyg
                                    key={formDisabled}
                                    onChangeEditor={this.handleEditor}
                                    disabled={formDisabledPartial || formDisabled}
                                    content={notificationForm.messageFR ? notificationForm.messageFR : ''}
                                    title={Translator.translate('general.table.column.message')}
                                    error={textInput_error.messageFR}
                                />
                            </Grid>

                            <Grid container item sm={12} md={6} lg={6}>
                                <FHEReactSelect
                                    name="type"
                                    label={Translator.translate('general.table.column.type')}
                                    disabled={formDisabledPartial || formDisabled}
                                    onChange={this.handleReactSelect}
                                    value={this.getSelectedType(notificationForm.type)}
                                    choices={this.types}
                                />
                            </Grid>

                            <Grid container item sm={12} md={6} lg={6}>
                                <FHEReactSelect
                                    name="priority"
                                    label={Translator.translate('general.table.column.priority')}
                                    disabled={formDisabledPartial || formDisabled}
                                    onChange={this.handleReactSelect}
                                    value={this.getSelectedPriority(notificationForm.priority)}
                                    choices={this.priorities}
                                />
                            </Grid>

                            <Grid container item sm={12} md={6} lg={6}>
                                <DateTimePicker
                                    minDate={!formDisabled && !formDisabledPartial && moment()}
                                    maxDate={moment.unix(notificationForm.endDate).subtract(1, 'days')}
                                    disabled={formDisabledPartial || formDisabled}
                                    className={classes.datePicker}
                                    ampm={false}
                                    variant="inline"
                                    label={Translator.translate('general.table.column.startDate')}
                                    value={notificationForm.startDate && moment.unix(notificationForm.startDate)}
                                    format="dd/MM/yyyy HH:mm"
                                    autoOk
                                    onChange={this.onStartDateChange}
                                    aria-describedby="fromDate-error-text"
                                />
                            </Grid>

                            <Grid container item sm={12} md={6} lg={6}>
                                <DateTimePicker
                                    minDate={
                                        formDisabled
                                            ? null
                                            : moment().add(1, 'days') < moment.unix(notificationForm.startDate)
                                            ? moment.unix(notificationForm.startDate).add(1, 'days')
                                            : moment().add(1, 'days')
                                    }
                                    disabled={formDisabled}
                                    className={classes.datePicker}
                                    ampm={false}
                                    variant="inline"
                                    label={Translator.translate('general.table.column.endDate')}
                                    value={notificationForm.startDate && moment.unix(notificationForm.endDate)}
                                    format="dd/MM/yyyy HH:mm"
                                    autoOk
                                    onChange={this.onEndDateChange}
                                    aria-describedby="fromDate-error-text"
                                />
                            </Grid>

                            <Grid container item sm={12}>
                                <Grid container item sm={12} md={6} lg={6}>
                                    <FHEReactSelect
                                        name="buttons"
                                        multiple
                                        label={Translator.translate('general.table.column.buttons')}
                                        disabled={formDisabledPartial || formDisabled}
                                        onChange={this.handleReactSelect}
                                        value={this.getSelectedButtons(buttonIds)}
                                        choices={defaultButtonsArray}
                                        customRender={this.customRender}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container item sm={12} md={3} lg={2}>
                                <FHERadio
                                    checked
                                    disabled={formDisabledPartial || formDisabled}
                                    choices={[
                                        { value: 'all_except', label: Translator.translate('generic.notification.userChoice.allExcept') },
                                        { value: 'nobody_except', label: Translator.translate('generic.notification.userChoice.nobodyExcept') }
                                    ]}
                                    title={Translator.translate('general.table.column.homesChoice')}
                                    onChange={this.handleChange}
                                    value={notificationForm.userChoice}
                                    name="userChoice"
                                />
                            </Grid>

                            <Grid container item sm={12} md={9} lg={10}>
                                <FHEReactSelect
                                    label={Translator.translate('general.Homes')}
                                    placeholder={Translator.translate('generic.notification.add.selectHome')}
                                    disabled={formDisabledPartial || formDisabled}
                                    searchable
                                    onChange={this.handleChangeReactSelect}
                                    multiple
                                    value={selectedHomes}
                                    choices={homesArray}
                                    closeMenuOnSelect={false}
                                />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                </FHEContainerScroll>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    let homesArray = [];
    const homes = state.environments.fhe.data.Homes.getIn(['list'], new Map());
    homes.forEach((home, key) => homesArray.push({ value: key, label: home.get('label') }));

    const defaultButtonsArray = [];
    const defaultButtons = state.environments.fhe.data.Notifications.getIn(['defaultButtons'], new Map());

    defaultButtons.forEach((data, key) => {
        const dataObj = data.toObject();
        dataObj.buttonId = key;
        defaultButtonsArray.push({
            value: key,
            label: dataObj.label,
            component: <NotificationButton content={dataObj} key={key} />,
            data: dataObj
        });
    });

    const notificationId = props.type === 'duplicate' ? props.location.state.notificationId : props.match.params.notificationId;

    return {
        notification: state.environments.fhe.data.Notifications.getIn(['list', notificationId], new Map()),
        defaultButtonsArray,
        defaultButtons,
        profile: state.data.user,
        homesArray,
        homes
    };
}

const styles = theme => ({
    reactSelect: {
        width: '100%'
    },
    radio: {
        width: 200
    },
    loadingContainer: {
        textAlign: 'center'
    },
    checkIcon: {
        color: theme.palette.success.main
    },
    datePicker: {
        width: '100%',
        paddingTop: 1,
        marginTop: 10
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({}, dispatch)
    )(withStyles(styles, { withTheme: true })(FormNotification))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Notification/Form/FormNotification.js